import { Injectable } from "@angular/core";
import { CustomerListRequestModel } from "../business-entities/customerList-request-model";
import { CustomerDataService } from "../data-services/customer-data.service";

@Injectable({
    providedIn: 'root'
})

export class CustomerService {
    customerId: number;
    vehicleId: number;
    customerNo: string;
    customerName: string;
    firstName:string;
    lastName:string;
    logo: any;
    customerMobileNo: string;
    customerFromCaller: any;
    contactId: string; //Guid of Customer
    customerListRequest: CustomerListRequestModel =
        {
            searchTerm: '',
            startRecordNumber: 0,
            pageSize: 25,
            sortColumn: '',
            sortDirection: '',
            isForDocuments: false,
            customerTypeId: 0,
            customerName: '',
            firstName:'',
            lastName:'',
            customerNo: '',
            customerGroup: null,
            salutation: null,
            postCode: null,
            city: null,
            email: '',
            mobile: '',
            licensePlateNo: '',
            statusId: 0,
            syncId: 0,
            sourceOfCreation: '',
            dealerName: '',
            isDeleted:false
        }
    customerDetail: any;//Used for Communication list
    constructor(private service: CustomerDataService) {
    }

    async GetPostCodeDropdown(): Promise<any> {
        return  this.service.GetPostCodeDropdown();
    }

    }
